import React, { useEffect, useState } from "react";
import CountdownTimer from "./CountdownTimer";
const moment = require("moment-timezone");
const ControlTiempo = (props) => {
  const [contador] = useState(0);
  const [tiempo, setTiempo] = useState(0);
  useEffect(() => {
    const targetTime = moment(props.targetDate).tz(
      "America/Guatemala"
    )
    setTiempo(targetTime);
  }, [contador]);
  return (
    <CountdownTimer targetDate={tiempo} finishTrigger={props.finishTrigger} />
  );
};

export default ControlTiempo;
